import React from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Gallery from './components/Gallery';
import ContactForm from './components/ContactForm';
import WhatsappButton from './components/WhatsappButton';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <div className="app-bg-logo" />
      <div>
        <Header />
        <Hero />
        <About />
        <Gallery />
        <ContactForm />
        <WhatsappButton phoneNumber="5514996146027" />
        <Footer />
      </div>
    </>
  );
}

export default App;
